import { NavLink } from "react-router-dom";

/** A strip of views of one thing.
 *
 *  Deliberately NOT role="tablist". These change the URL — which is the point,
 *  so a history view can be linked and survives a reload — and ARIA's tab
 *  pattern promises a screen reader that panels swap in place without
 *  navigating. Claiming it for links would describe something the page does
 *  not do. NavLink's own aria-current="page" is the honest marker, and
 *  components.css already styles that state for the header nav. */
export function Tabs({ tabs }: { tabs: { to: string; label: string; end?: boolean }[] }) {
  return (
    <nav className="tabs">
      {tabs.map((tab) => (
        <NavLink key={tab.to} to={tab.to} end={tab.end}>{tab.label}</NavLink>
      ))}
    </nav>
  );
}
